import { Field, Model, CodeModel, FIELD_TYPES } from "@/vue-ocom/schema";

export default Model("form_entry_workflow_state", {
  verbose_name: "Form Entry Workflow State",
  verbose_name_plural: "Form Entry Workflow States",
  fields: [
    Field("id", {
      label: "ID",
      primary_key: true,
      readonly: true,
      hide: false,
      field_type: FIELD_TYPES.AutoNumber,
    }),

    Field("instance", {
      label: "Instance",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "FormEntry",
      ref_display_field: "other_name",
      default: () => {
        return null;
      },
    }),
    Field("instance__other_name", {
      label: "Instance",
      primary_key: false,
      readonly: true,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return null;
      },
    }),
    Field(
      "instance__form_template_version__form_template_versions__name",
      {
        label: "Template Name",
        primary_key: false,
        readonly: true,
        required: false,
        hide: false,
        field_type: FIELD_TYPES.String,
        default: () => {
          return null;
        },
      }
    ),
    Field("state", {
      label: "State",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return "";
      },
    }),
    Field("description", {
      label: "Description",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return "";
      },
    }),
    Field("role", {
      label: "Role",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Number,
      default: () => {
        return null;
      },
    }),
    Field("who", {
      label: "Who",
      primary_key: false,
      readonly: false,
      required: true,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "User",
      ref_display_field: "username",
      default: () => {
        return null;
      },
    }),
    Field("who__username", {
      label: "Who",
      primary_key: false,
      readonly: true,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return null;
      },
    }),

    Field("created_date", {
      label: "Created Date",
      primary_key: false,
      readonly: true,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      },
    }),
    Field("modified_date", {
      label: "Modified Date",
      primary_key: false,
      readonly: true,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      },
    }),
    Field("completed_date", {
      label: "Completed Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      },
    }),
    Field("started_date", {
      label: "Started Date",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return new Date().toISOString().split("T")[0];
      },
    }),

    /* Instance Data */
    Field("instance__submitted_date", {
      label: "Submitted Date",
      primary_key: false,
      readonly: true,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      },
    }),
    Field("instance__submitted_user", {
      label: "Submitted User",
      primary_key: false,
      readonly: true,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Integer,
      default: () => {
        return null;
      },
    }),
    Field("instance__submitted_user__username", {
      label: "Submitted User",
      primary_key: false,
      readonly: true,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return null;
      },
    }),
    Field("instance__created_user", {
      label: "Created User",
      primary_key: false,
      readonly: true,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Integer,
      default: () => {
        return null;
      },
    }),
    Field("instance__created_user__username", {
      label: "Created User",
      primary_key: false,
      readonly: true,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return null;
      },
    }),
    Field("instance__created_date", {
      label: "Created Date",
      primary_key: false,
      readonly: true,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      },
    }),
  ],
});
